import styled from 'styled-components'
import { P, Typography } from 'common/typography'
import { MdLink } from 'react-icons/md'
import ContentRender from 'content-renderer'
import { INPROGRESS } from 'utils/project-status'
import { useProfile } from 'querys/profile'
import Stack from './stack'

const PStyled = styled(P)`
  margin: 8px 0 24px;
  line-height: 24px;
`

const ProjectFeedBack = styled.ul`
  margin-bottom: 24px;
  li {
    color: var(--neutral);
    margin: 16px 0;
    padding-left: 16px;
    position: relative;
    &::before{
      position: absolute;
      width: 8px;
      height: 8px;
      top: 8px;
      left: 0px;
      content: '';
      display: block;
      background-color: var(--secondary);
      border-radius: 50%;
    }
  }
`

const ProjectNormal = styled.div`
  .git-link {
    color: var(--turquoise);
  }
  p,
  .project-description li {
    line-height: 24px;
    display: none;
    margin: 0;
    &:first-of-type {
      overflow: hidden;
      margin: 8px 0;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  @media(min-width: 768px) {
    p:first-of-type, li:first-of-type {
      -webkit-line-clamp: 2;
    }
  }
`

function ProjectDescription({
  status, repository_slug, feedback, stack, title, blocks,
}) {
  const { data: { info } } = useProfile()
  if (!repository_slug) {
    return (
      <>
        <Typography small="headline6" large="headline5" as="h3">
          Solicitar revisión
        </Typography>
        <PStyled color="var(--neutral)">
          Vincula este proyecto al repositorio que corresponde en tu cuenta de GitHub, para poder solicitar su revisión y recibir feedback en Discord.
        </PStyled>
      </>
    )
  }

  if (status === INPROGRESS && feedback) {
    return (
      <>
        <Typography small="headline6" large="headline5" as="h3">
          Resuelve los siguientes puntos
        </Typography>
        <PStyled color="var(--neutral)">
          Una vez resueltos los siguientes issues solicita una nueva revisión.
        </PStyled>
        <ProjectFeedBack>
          {feedback.map(({ message, message_url }) => (
            <li key={message_url}>{message}</li>
          ))}
        </ProjectFeedBack>
      </>
    )
  }

  return (
    <ProjectNormal>
      <Typography small="headline6" large="headline5" as="h3">
        {title}
      </Typography>
      <div className="project-description">
        <ContentRender chunks={blocks} color="var(--neutral)" id={title} />
      </div>
      <Stack stack={stack} />
      <div className="git-link">
        <MdLink color="var(--turquoise)" size="30px" />
        <a href={`https://github.com/${info.github_username}/${repository_slug}`}>{info.github_username}/{repository_slug}</a>
      </div>
    </ProjectNormal>
  )
}

export default ProjectDescription
